import { useState } from "react";
import Header from "./Header";
import PopUp from "./PopUp";

const FrameComponent = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        className="self-stretch flex flex-col w-[1440px] items-center justify-centerss py-0 pr-2.5 pl-0 box-border gap-[41px] max-w-full text-center text-85xl text-black font-libre-baskerville mq750:gap-[20px]"
        id="home"
      >
        <Header onJoinWaitlist={() => setShowModal(true)} />

        {/* Hero section */}
        <div className="self-stretch flex flex-col items-center justify-start py-0 px-5 box-border gap-[40px] max-w-full">
          <div className="w-[947px] flex flex-row items-start justify-start max-w-full mq750:gap-[100px] mq1050:gap-[151px]">
            <h1 className="m-0 flex-1 relative text-inherit tracking-[-1px] leading-[110%] inline-block max-w-full font-inherit mq1050:text-33xl mq1050:leading-[69px] mq450:text-12xl mq450:leading-[46px]">
              <p className="m-0">Transform your</p>
              <p className="m-0">
                <i className="text-transparent !bg-clip-text [background:linear-gradient(97.56deg,_#472723,_#110302)] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">
                  Closet
                </i>
                <span className="font-libre-baskerville">
                  <span className="text-gray-100">{` `}</span>
                  <span className="text-black">Today</span>
                </span>
              </p>
            </h1>
          </div>
          <div className="w-[947px] flex flex-row items-start justify-center py-0 px-5 box-border max-w-full text-left text-lg text-gray-200 font-inter">
            <div className="relative leading-[20px] font-light">
              Unlock the full potential of your wardrobe with Closetrove - your
              digital closet.
            </div>
          </div>
          <div>
            <button
              className="cursor-pointer [border:none] py-3 px-5 bg-[transparent] w-[325px] mq450:w-[280px] rounded-81xl [background:linear-gradient(97.56deg,_#472723,_#110302)] flex flex-row items-center justify-center hidden mq1050:block mq750:block mq450:block box-border whitespace-nowrap max-w-full"
              onClick={() => setShowModal(!showModal)}
            >
              <b className="relative text-smi-5 tracking-[-0.14px] leading-[18px] inline-block font-inter text-white text-left min-w-[88px]">
                Join Waitlist
              </b>
            </button>
            {/* <button className="cursor-pointer [border:none] py-3 w-[100%] px-[58.5px] bg-[transparent] rounded-81xl [background:linear-gradient(97.56deg,_#472723,_#110302)] flex flex-row items-start hidden mq1050:block mq750:block mq450:block justify-start whitespace-nowrap">
            <b className="relative text-smi-5 tracking-[-0.14px] leading-[18px] inline-block font-inter text-white text-left min-w-[88px]">
              <a href="" className="text-[#FFFFFF] no-underline ">
                Download App
              </a>
            </b>
          </button> */}
          </div>
        </div>
      </div>

      {showModal ? (
        <>
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50">
            <div className="w-[70%] justify-center items-center flex flex-col overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
              <PopUp showModal={showModal} setShowModal={setShowModal} />
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      ) : null}
    </>
  );
};

export default FrameComponent;
